import axios from "@/axios";
import { AxiosResponse } from "axios";
import { GetAdunitsParameter, PublishersAdunitResponse } from "@/commons/types";

/**
 * Get adunitList by publisherId.
 * @param publisherId
 */
export function getAdunits(
  getArg: GetAdunitsParameter
): Promise<AxiosResponse<PublishersAdunitResponse>> {
  return axios.get<PublishersAdunitResponse>(`/publishers/${getArg.publisherId}/adunits/`, {
    params: {
      reportType: getArg.reportType,
      page: getArg.index,
      name: getArg.name,
    },
  });
}
